module.exports = __webpack_public_path__ + "img/29.5cd0c840.png";